import { render, staticRenderFns } from "./authenticate-github.vue?vue&type=template&id=49e5a50b&scoped=true"
import script from "./authenticate-github.js?vue&type=script&lang=js&external"
export * from "./authenticate-github.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e5a50b",
  null
  
)

export default component.exports